import React, { useState } from 'react';
import { Button, Container, Paper, Stack, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';

export default function SessionVerificationError({ onRetry }) {
  const { sessionError, loading, verifySession, logout } = useAuth();
  const [signOutError, setSignOutError] = useState(null);

  async function signOut() {
    setSignOutError(null);
    try {
      await logout();
    } catch (error) {
      setSignOutError('Could not sign out. Reload the page and try again.');
    }
  }

  return (
    <>
      <Header />
      <Container maxWidth="sm" sx={{ mt: '6rem', mb: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Stack spacing={2}>
            <Typography variant="h4">Session verification failed</Typography>
            <Typography role="alert">{signOutError || sessionError}</Typography>
            <Button variant="contained" disabled={loading} onClick={() => {
              setSignOutError(null);
              if (onRetry) onRetry();
              else verifySession();
            }}>
              {loading ? 'Checking...' : 'Retry session check'}
            </Button>
            <Button disabled={loading} onClick={signOut}>Sign out</Button>
          </Stack>
        </Paper>
      </Container>
    </>
  );
}
